import { Box, Divider, Flex, Text } from '@chakra-ui/layout';
import theme from '@chakra-ui/theme';
import type { CSSProperties } from 'react';
import { Textfit } from 'react-textfit';

import { useResizeObserver } from '@revelio/core';
import type { GetEntityDataV2Query } from '@revelio/data-access';

type CompanySummaryProps = {
  data: GetEntityDataV2Query;
  isDragging?: boolean;
};

const TEXT_STYLES: CSSProperties = {
  height: 'calc(100% - 4px)',
  lineHeight: '1.2',
  fontWeight: 300,
  overflow: 'hidden',
};

export const CompanySummary = ({ data, isDragging }: CompanySummaryProps) => {
  const factSize = '44px';

  const { containerRef, width, height } = useResizeObserver();

  const entity = data.entityV2?.entity;
  const description = entity?.description;
  const founded = entity?.founded;
  const headquarters = entity?.headquarters;

  return (
    <Flex height="100%" flexDirection="column" justifyContent="space-between">
      <Box
        overflow="hidden"
        height={`calc(100% - ${factSize})`}
        ref={containerRef}
      >
        {isDragging || !(width && height) ? (
          <Text style={TEXT_STYLES}>{description}</Text>
        ) : (
          <Textfit mode="multi" min={10} max={200} style={TEXT_STYLES}>
            <Text>{description}</Text>
          </Textfit>
        )}
      </Box>

      <Box overflow="hidden" height={factSize}>
        <Divider marginBottom={4} marginTop={0} />
        <Flex>
          <Flex
            pr={3}
            mr={3}
            borderRight={`1px solid ${theme.colors.gray[200]}`}
          >
            <Text fontSize={14} fontWeight={600} mr={1}>
              Founded:
            </Text>
            <Text fontSize={14} fontWeight={300}>
              {founded}
            </Text>
          </Flex>
          <Text fontSize={14} fontWeight={600} mr={1}>
            Headquarters:
          </Text>
          <Text
            fontSize={14}
            fontWeight={300}
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
            title={headquarters || ''}
          >
            {headquarters}
          </Text>
        </Flex>
      </Box>
    </Flex>
  );
};
